import createReactComponent from '../createReactComponent';
export default createReactComponent('mobile-signal-two', 'MobileSignalTwo', [["path",{"d":"M3 21v-1m4.5 1v-5","key":"svg-0"}]]);